/** MLB team primary colors keyed by `Mapping_Name` from inputs/team_mapping.parquet.
 *
 * Aliases are provided for naming variants we've seen in the data (e.g. "Oakland"
 * vs "Athletics"). Where a team's primary navy clashes with another team's primary
 * navy, we substitute a distinctive secondary brand color so the lines stay
 * readable on a 30-team chart.
 */

export const TEAM_COLORS: Readonly<Record<string, string>> = {
  Arizona: '#A71930',
  Atlanta: '#CE1141',
  Baltimore: '#DF4601',
  Boston: '#BD3039',
  'Chicago Cubs': '#0E3386',
  'Chicago White Sox': '#27251F',
  Cincinnati: '#C6011F',
  Cleveland: '#E50022',
  Colorado: '#333366',
  Detroit: '#FA4616',
  Houston: '#EB6E1F',
  'Kansas City': '#004687',
  'LA Angels': '#BA0021',
  'LA Dodgers': '#005A9C',
  Miami: '#00A3E0',
  Milwaukee: '#FFC52F',
  Minnesota: '#D31145',
  'NY Mets': '#FF5910',
  'NY Yankees': '#003087',
  Oakland: '#006341',
  Athletics: '#006341',
  Philadelphia: '#E81828',
  Pittsburgh: '#FDB827',
  'San Diego': '#FFC425',
  'San Francisco': '#FD5A1E',
  Seattle: '#005C5C',
  'St. Louis': '#C41E3A',
  'Tampa Bay': '#8FBCE6',
  Texas: '#003278',
  Toronto: '#134A8E',
  Washington: '#AB0003',
}

/** A neutral fallback so unknown teams still render. */
export const TEAM_COLOR_FALLBACK = '#64748b'

export function teamColor(name: string): string {
  return TEAM_COLORS[name] ?? TEAM_COLOR_FALLBACK
}

/** Build aligned domain + range arrays for a Vega-Lite nominal color scale. */
export function teamColorScale(teams: ReadonlyArray<string>): { domain: string[]; range: string[] } {
  const domain = [...teams]
  const range = domain.map(teamColor)
  return { domain, range }
}
